import React from 'react'
import PropTypes from 'prop-types'

const VoicemailDataBox = (props) => {
  const { voicemail } = props
  const disclaimer = ['**DISCLAIMER: Robots created this transcipt, so please cut ',
    'them some slack**']

  return (
    <div className="voicemailDataBox">
      <div className="audioBox">
        <audio
          controls
          src={
            `${process.env.REACT_APP_API_BASE_URL}/api/v1/voicemail?s3_email_id=${voicemail.s3_email_id}`
          }
          label="voicemail"
        >
          <track kind="captions" />
        </audio>
      </div>
      <div className="transcriptBox">
        <h3>Transcript:</h3>
        <p className="transcript">{voicemail.transcript}</p>
        <p className="disclaimer">{disclaimer}</p>
      </div>
    </div>
  )
}

VoicemailDataBox.propTypes = {
  voicemail: PropTypes.object.isRequired,
}

export default VoicemailDataBox



// WEBPACK FOOTER //
// ./src/components/CallLog/CallLogPage/VoicemailDataBox.js